module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/gXisX1/media/FC-9781685623272.jpg?1685790893065",
      "alt": "This image is the cover for the book Anya"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Anya\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', {
    staticStyle: {
      "margin-top": "0cm",
      "margin-right": "0cm",
      "margin-bottom": "8.0pt",
      "margin-left": "0cm",
      "font-size": "15px",
      "font-family": "\"Calibri\",sans-serif"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "16px",
      "font-family": "\"Arial Nova\",sans-serif"
    }
  }, [_c('em', [_vm._v("Anya")]), _vm._v(", a modern romance novel, follows the story of a young woman from Russia who comes to the United States for college. Despite her fluency in English, her accent makes her a target for bullies. As she struggles to adjust to life in a new country, she meets Peter, a wealthy student who takes an immediate interest in her. Despite the challenges of navigating a new campus and dealing with romantic competition, Peter remains devoted to Anya, even going so far as to help her cancer-stricken mother in Russia. As their relationship develops, Anya must navigate her own conflicting emotions and desires, ultimately leading to a dramatic conclusion. The outcome of their love story is left for readers to discover.")])]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Dennis K. Hausker\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }), _c('p', [_vm._v("Dennis K. Hausker is a retired financial consultant and Vietnam war veteran who graduated from Michigan State University in 1969. He is an avid fan of Spartan sports and enjoys traveling, attending family events, and savoring good food. Dennis met his wife, who hails from Maine and was a warm and nurturing teacher, while they were both in college. They have been happily married ever since. Dennis is known for his positive attitude, which he believes is the key to a fulfilling life.")]), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0